import { cn } from "@/lib/utils";

const STYLES = {
  high: "bg-red-50 text-red-800 border-red-200",
  medium: "bg-amber-50 text-amber-800 border-amber-200",
  low: "bg-teal-50 text-teal-800 border-teal-200",
};

export default function RiskBadge({ level, score, className }) {
  const tone = STYLES[level] || STYLES.low;
  return (
    <span
      data-testid={`risk-badge-${level}`}
      className={cn(
        "inline-flex items-center gap-1.5 border px-2 py-0.5 rounded-md text-xs font-medium font-mono",
        tone,
        className,
      )}
    >
      <span className="uppercase tracking-wider">{level}</span>
      {score !== undefined && <span className="opacity-70">· {score}</span>}
    </span>
  );
}
